if (!customElements.get('swk-testimonials-slider')) {
  customElements.define(
    'swk-testimonials-slider',
    class SwkTestimonialsSlider extends HTMLElement {
      constructor() {
        super();
        this.onBreakpointChange = this.onBreakpointChange.bind(this);
      }

      connectedCallback() {
        this.mql = window.matchMedia('(max-width: 650px)');
        this.mql.addEventListener('change', this.onBreakpointChange);
        this.onBreakpointChange();
      }

      disconnectedCallback() {
        this.mql?.removeEventListener('change', this.onBreakpointChange);
        this.destroySwiper();
      }

      onBreakpointChange() {
        if (this.mql.matches) {
          this.classList.add('swk-testimonials-slider--swiper');
          this.initSwiper();
        } else {
          this.classList.remove('swk-testimonials-slider--swiper');
          this.destroySwiper();
        }
      }

      initSwiper() {
        if (this.swiper) return;

        const swiperEl = this.querySelector('.swk-testimonials__swiper');
        if (!swiperEl) return;

        if (typeof Swiper === 'undefined') {
          window.addEventListener('load', () => this.initSwiper(), { once: true });
          return;
        }

        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const slideWidth = this.dataset.slideWidth || '40';
        const slideWidthUnit = this.dataset.slideWidthUnit || 'rem';
        const spaceBetween = parseFloat(this.dataset.spaceBetween || '1.6') * rem;
        const loop = this.dataset.loop === 'true';
        const slidesPerView = this.dataset.slidesPerView || 'auto';

        this.style.setProperty('--slide-width', `${slideWidth}${slideWidthUnit}`);

        this.swiper = new Swiper(swiperEl, {
          slidesPerView,
          spaceBetween,
          loop,
          speed: 600,
        });
      }

      destroySwiper() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}
